/**
 * smb自助业务业务相关
 */
import * as types from 'src/store/types';
import { getAbVersion } from 'src/service/index';

export default {
  namespaced: true,
  state: {
    hasFetchedAb: false, // 是否已经拉取ab接口
    payment_sdk_integration_v2: false, // Payment SDK 接入实验 - 二期
    payment_sdk_skippable: false, // Payment SDK 创编提交 先付费弹窗可跳过 实验
    enable_tutorial: false, // 新手引导
    enable_new_guide: false, // 新手引导优化
    enable_1v1: false, // 新手引导工单 1v1
    hide_manual_pay: false, // 支付切换是否用新样式
  },
  mutations: {
    [types.SET_HAS_FETCHED_AB](state, data) {
      state.hasFetchedAb = data;
    },
    [types.SET_NEW_CUSTOMER](state, data) {
      state.enable_tutorial = data.enable_tutorial || false; // 新手引导
      state.enable_1v1 = data.enable_1v1 || false; // 新手引导工单 1v1
      state.enable_new_guide = data.enable_new_guide || false; // 新手引导优化
    },
    [types.SET_PAYMENT_SDK_ABTESTS](state, data) {
      state.payment_sdk_integration_v2 = data.payment_sdk_integration_v2;
      state.payment_sdk_skippable = data.payment_sdk_skippable;
    },
    [types.SET_PAYMENT_CHANGE_ABTEST](state, data) {
      state.hide_manual_pay = data;
    },
  },
  actions: {
    async getPaymentChangeABTest({ commit }) {
      const data = await getAbVersion(
        {
          ab_feature: 'payment_method',
        },
        'payment_method',
      );
      commit(types.SET_PAYMENT_CHANGE_ABTEST, data.hide_manual_pay || false);
    },
  },
};
